import { helper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';
import { isPresent } from '@ember/utils';

export function heatmap(
  [rgb, value]: [string, number],
  { attribute }: { attribute?: string } = {}
) {
  const hasValue = isPresent(value) && value !== 1.0;

  const opacity = hasValue ? Math.min(Math.abs(1 - value), 1) : 0;
  return htmlSafe(
    `${attribute ?? 'background-color'}: ${
      hasValue ? `rgba(${rgb}, ${opacity})` : 'var(--bv-color-surface-subdued)'
    }
    ${hasValue && opacity === 1 ? '; color: white' : ''}
    `
  );
}

export default helper(heatmap);
